var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"progressBar",staticClass:"progress-bar",on:{"click":_vm.progressClick}},[_c('div',{staticClass:"bar-inner"},[_c('div',{ref:"progress",staticClass:"progress"}),_c('div',{ref:"progressBtn",staticClass:"progress-btn-wrapper"},[_c('div',{staticClass:"progress-btn",class:{show: _vm.alwaysShowBtn}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }